module.exports = __webpack_public_path__ + "static/media/product_1.786874c2.jpg";